export const deleteProduct = (payload: { id: number, mode?: string }) => ({
    type: "@saga/DELETE_PRODUCT",
    payload
});